import { lazy, Suspense } from "react";
import { Routes, Route } from "react-router-dom";
import "./App.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "./assets/kangaroo.css";
import "./assets/fonts/fonts.css";

// Eagerly load critical components
import ScrollToTop from "./component/ScrollTop/ScrollToTop";
import MainLayout from "./page/Layout/MainLayout";

// Lazy load page components
const Homepage = lazy(() => import("./Homepage/Homepage"));
const JoinSuccess = lazy(() => import("./Homepage/JoinSuccess"));
const Page3 = lazy(() => import("./Homepage/LearnMore"));
const About = lazy(() => import("./pages/AboutPage/page/About"));
const TestPreparation = lazy(() => import("./pages/TestPreparationPage/page/TestPreparation"));
const Ielts = lazy(() => import("./pages/IeltsPage/page/Ielts"));
const InstitutionPage = lazy(() => import("./pages/InstitutionPage/page/InstitutionPage"));
const CountryPage = lazy(() => import("./pages/CountryPage/page/CountryPage"));
const AboutLanding = lazy(() => import("./pages/AboutPage/page/AboutLanding"));
const InstitutionRepresent = lazy(() => import("./pages/InstitutionWeRepresent/page/InstitutionRepresent"));
const Destination = lazy(() => import("./pages/DestinationPage/page/Destination"));
const CareerLanding = lazy(() => import("./pages/CareerPage/page/CareerLanding"));
const AboutPartner = lazy(() => import("./pages/AboutPage/page/AboutPartner"));
const AboutMilestone = lazy(() => import("./pages/AboutPage/page/AboutMilestone"));
const CareerDetail = lazy(() => import("./pages/CareerPage/page/CareerDetail"));
const Blog = lazy(() => import("./pages/BlogPage/page/Blog"));
const BlogLanding = lazy(() => import("./pages/BlogPage/page/BlogLanding"));
const Event = lazy(() => import("./pages/EventPage/page/Event"));
const EventDetail = lazy(() => import("./pages/EventPage/page/EventDetail"));
const Franchise = lazy(() => import("./pages/FranchisePage/page/Franchise"));
const Contact = lazy(() => import("./pages/ContactPage/page/Contact"));
const Getfreecounseling = lazy(() => import("./pages/GetFreeCounseling/page/Getfreecounseling"));
const FranchiseHidden = lazy(() => import("./pages/FranchisePage/page/FranchiseHidden"));

// Loading fallback component
const LoadingFallback = () => (
  <div style={{
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    minHeight: '60vh',
    fontSize: '1.2rem',
    color: '#666'
  }}>
    Loading...
  </div>
);

function App() {
  return (
    <>
      <ScrollToTop />
      <Suspense fallback={<LoadingFallback />}>
        <Routes>
          <Route element={<MainLayout />}>
            <Route path="/" element={<Homepage />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/freecounseling" element={<Getfreecounseling />} />
            <Route path="/about/aboutceo" element={<About />} />
            <Route path="/about/whoweare" element={<AboutLanding />} />
            <Route path="/about/partner" element={<AboutPartner />} />
            <Route path="/about/milestone" element={<AboutMilestone />} />
            <Route path="/institutionrepresent" element={<InstitutionRepresent />} />
            <Route path="/corporate/career" element={<CareerLanding />} />
            <Route path="/corporate/career/:jobTitle" element={<CareerDetail />} />
            <Route path="/testpreparation" element={<TestPreparation />} />
            <Route path="/blog" element={<BlogLanding />} />
            <Route path="/events" element={<Event />} />
            <Route path="/corporate/franchise" element={<Franchise />} />
            <Route path="/corporate/franchisehidden" element={<FranchiseHidden />} />
            <Route path="/events/:eventID" element={<EventDetail />} />
            <Route path="/blog/:id" element={<Blog />} />
            <Route path="/testpreparation/:section" element={<Ielts />} />
            <Route path="/innerpage/:section" element={<CountryPage />} />
            <Route path="/studyabroad" element={<Destination />} />
            <Route path="/destination/:id" element={<InstitutionPage />} />
          </Route>
        </Routes>
      </Suspense>
    </>
  );
}

export default App;